<template>
  <SecuritySettings />
</template>

<script setup>
import SecuritySettings from "@/components/profile/SecuritySettings.vue";
</script>
